var exports = {
  "kL": "DiscoverySearchFilters.module__container___M1FxQ1",
  "uW": "DiscoverySearchFilters.module__section___M1FxQ1",
  "SF": "DiscoverySearchFilters.module__sectionHeading___M1FxQ1",
  "jv": "DiscoverySearchFilters.module__categoryList___M1FxQ1",
  "af": "DiscoverySearchFilters.module__categoryItem___M1FxQ1",
  "Cm": "DiscoverySearchFilters.module__categoryItemActive___M1FxQ1",
  "Jm": "DiscoverySearchFilters.module__categoryLabel___M1FxQ1",
  "_E": "DiscoverySearchFilters.module__categoryCount___M1FxQ1",
};

module.exports = exports;
